import { base44 } from '@/api/base44Client';

export const RESPONSIVE_TARGETS = { desktop: 2400, tablet: 1600, mobile: 1200 };

const loadImage = (src) => new Promise((resolve, reject) => {
  const img = new Image();
  img.crossOrigin = 'anonymous';
  img.onload = () => resolve(img);
  img.onerror = () => reject(new Error("Impossibile caricare l'immagine originale"));
  img.src = src;
});

// Generate modern WebP assets when supported, with a compressed JPEG fallback.
const canvasToBlob = (canvas) => new Promise((resolve, reject) => {
  canvas.toBlob((blob) => {
    if (blob && blob.type === 'image/webp') return resolve({ blob, ext: 'webp' });
    canvas.toBlob((jpeg) => (jpeg ? resolve({ blob: jpeg, ext: 'jpg' }) : reject(new Error('Conversione non riuscita'))), 'image/jpeg', 0.85);
  }, 'image/webp', 0.78);
});

// Stepped downscale preserves photographic sharpness on large reductions.
const resizeToCanvas = (img, targetW, targetH) => {
  let source = img;
  let w = img.naturalWidth;
  let h = img.naturalHeight;
  while (w / 2 > targetW) {
    const c = document.createElement('canvas');
    c.width = Math.round(w / 2);
    c.height = Math.round(h / 2);
    const ctx = c.getContext('2d');
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(source, 0, 0, c.width, c.height);
    source = c;
    w = c.width;
    h = c.height;
  }
  const out = document.createElement('canvas');
  out.width = targetW;
  out.height = targetH;
  const ctx = out.getContext('2d');
  ctx.imageSmoothingQuality = 'high';
  ctx.drawImage(source, 0, 0, targetW, targetH);
  return out;
};

// Generates desktop/tablet/mobile versions (original ratio, no crop, no upscale) and uploads them.
export async function generateResponsiveVersions(imageUrl, onProgress) {
  const img = await loadImage(imageUrl);
  const ow = img.naturalWidth;
  const oh = img.naturalHeight;
  const result = { generated_at: new Date().toISOString() };
  const entries = Object.entries(RESPONSIVE_TARGETS);
  for (let i = 0; i < entries.length; i++) {
    const [name, longSide] = entries[i];
    onProgress?.(name, i + 1, entries.length);
    const scale = Math.min(1, longSide / Math.max(ow, oh));
    const tw = Math.max(1, Math.round(ow * scale));
    const th = Math.max(1, Math.round(oh * scale));
    const canvas = resizeToCanvas(img, tw, th);
    const { blob, ext } = await canvasToBlob(canvas);
    const file = new File([blob], `responsive-${name}.${ext}`, { type: blob.type });
    const { file_url } = await base44.integrations.Core.UploadFile({ file });
    result[name] = { url: file_url, width: tw, height: th };
  }
  return result;
}

export const pickVersionName = (viewportWidth) =>
  viewportWidth < 768 ? 'mobile' : viewportWidth < 1280 ? 'tablet' : 'desktop';